import React, { useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { AthleteProps, EventProps, LeagueProps, MatchProps, OrderProps, TeamProps, TournamentProps } from "../../types"
import { useColors } from '../../constants/useColors';
import { Icons } from '../../Components';
import { MyActionHelpers } from '../api';
import { FlatList, Image } from 'react-native';
import { AthleteImage, TeamImage } from '../../Components/Jerseys';
import { MarketComponentHelpers } from '../../MarketComponents/api';

type ContestStatRowProps = {
    market_type:'FOR_MONEY'|'FREE',
    contest_label:string,
    time_detail:string,
    orders:OrderProps[],
    leagues:LeagueProps[],
    events:EventProps[],
    tournaments:TournamentProps[],
    matches:MatchProps[],
    athletes:AthleteProps[],
    teams:TeamProps[],
    width:number
}

const ContestStatRow = ({ market_type, contest_label, orders, width, events, tournaments, matches, athletes, teams, leagues }:ContestStatRowProps) => {
    const Colors = useColors();
    const [ expanded, setExpanded ] = useState(false);
    const stats = MyActionHelpers.calcAllOrderStats(orders);
    const stake = stats.unresolved_stake + stats.resolved_stake
    const potential_winnings = stats.unresolved_potential_winnings + stats.resolved_potential_winnings
    const cl = market_type == 'FOR_MONEY' ? '$' : 'E'
    //Is this in progress?
    const in_progress = stats.open_amt > 0 ? true : false
    const settled = stats.result_ind ? true : false


    const renderLegResult = (result_ind?:'win'|'lose'|'draw'|'inprogress') => {
        switch(result_ind){
            case 'win':
                return <Icons.CheckIcon size={14} color={Colors.text.success} />
            case 'lose':
                return <Icons.CloseIcon size={14} color={Colors.text.error} />
            case 'draw':
                return <Icons.AlertIcon size={14} color={Colors.text.warning}/>
            default:
                return <Icons.ActivityIcon size={14} color={Colors.text.h1} />
        }
    }

 const renderOrders = (data:{ item:OrderProps, index:number }) => {
        const { contest_title, athlete, team, league } = MyActionHelpers.getDetailsForOrder(data.item, events, tournaments, matches, athletes, teams, leagues);
        const result_ind = data.item.positions[0]?.result_ind
        return (
            <View type='row' style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                {team ?
                <TeamImage
                    team={team}
                    league={league}
                    size={10}
                />
                :athlete ?
                <AthleteImage
                    athlete={athlete}
                    league={league}
                    size={24}
                />
                :league ?
                <Image
                    source={{ uri: league.league_image }}
                    style={{ height:18, width:18 }}
                    resizeMode="cover"
                />
                :<></>
                }
                
                <View transparent style={{ flex:1, marginLeft:8 }}>
                    <Text theme='h2'>{data.item.title}</Text>
                    <View transparent style={{ marginTop:3 }}>                            
                        <Text theme="description">{contest_title}</Text>
                    </View>
                </View>
                {data.item.resolution_status != 'closed' ?
                <Button float style={{  marginRight:4, marginLeft:4, padding:10, flexDirection:'row', justifyContent:'center', alignItems:'center' }} onPress={() => console.log('ehy')}>
                    <Icons.ActivityIcon size={18} color={Colors.text.action} />
                    <Text theme="action"> View</Text>
                </Button>
                :<></>}
                <View style={{ padding:10 }}>
                    <Text theme="description">{MarketComponentHelpers.getOddsLabel(data.item.odds)}</Text>
                </View>
                {renderLegResult(result_ind)}
                {result_ind == 'draw' ? 
                <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'center' }}>
                    <View style={{ borderBottomWidth:1, borderColor:Colors.borders.light, marginRight:20, marginLeft:20 }} />
                </View>
                :<></>}
            </View>
        )
    }

    return (
        <View transparent style={{ borderWidth:expanded ? 1: 0, borderColor:expanded ? Colors.text.action: undefined }}>
            <View type='row' style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light, flexWrap:'wrap' }}>
                <Button float style={{ padding:5 }}>
                    <Icons.OrderIcon size={14} color={Colors.text.action} />
                </Button>
                <Button transparent style={{ borderRadius:0, padding:0, borderLeftWidth:1, borderColor:Colors.borders.light, flexGrow:1, marginLeft:6, paddingLeft:6, minWidth:75 }} onPress={() => setExpanded(!expanded)}>
                    <Text theme='h1' style={{ maxWidth: width * 0.5 }}>{contest_label}</Text>
                    <Text theme='light' color={Colors.text.action} style={{ marginTop:3 }}>See {orders.length} Orders</Text>
                </Button>
                {width > 500 ?
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{orders.length}</Text>
                    <Text theme='light'>Orders</Text>
                </View>
                :<></>}
                {in_progress ?
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1' color={Colors.text.warning}>{stats.open_amt.toFixed(2)}</Text>
                    <Text theme='light' color={Colors.text.warning}>Open</Text>
                </View>
                :<></>}
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{stake.toFixed(2)}</Text>
                    <Text theme='light'>Risk</Text>
                </View>
                {settled ?
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{stats.winnings.toFixed(2)}</Text>
                    <Text theme='light'>Winnings</Text>
                </View>
                :
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{potential_winnings.toFixed(2)}</Text>
                    <Text theme='light'>Potential</Text>
                </View>
                }
            </View>
            {expanded ?
            <View transparent style={{ padding:10 }}>
                <FlatList
                    data={orders}
                    keyExtractor={item => item.order_id.toString()}
                    renderItem={renderOrders}
                    key={`contest_${contest_label}_orders`}
                    />
            </View>
            :<></>}
        </View>
    )
}

export default ContestStatRow